module.exports = __webpack_public_path__ + "assets/devices/TOWER-20AM-PG2-545f9227b333a17fcc3dc96576b14530.svg";